import { DaTeacher } from '../generated/DaTeacher';
import { Lessons } from '../generated/Lessons';
import { ShiftTable } from '../generated/ShiftTable';
import { Student } from '../generated/Student';
import { Teacher } from '../generated/Teacher';
import { UserBuildings } from '../generated/UserBuildings';

export class LessonDTO {
  lessons!: Lessons;
  student?: Student;
  teacher?: Teacher;
  da_teacher?: DaTeacher;
  user_building?: UserBuildings;
  shift_table?: ShiftTable;
  commit = false;
  isRecent = false;
}
